import DateHelper from '../Utility/DateHelper';

export const SHOP_REWARD_COOLDOWN = DateHelper.hoursToMilliseconds(12);
export const FOX_REWARD_COOLDOWN = DateHelper.hoursToMilliseconds(12);
export const WHEEL_COOLDOWN = DateHelper.hoursToMilliseconds(12);
export const FRIEND_GIFT_COOLDOWN_IOS = DateHelper.daysToMilliseconds(3);
export const FRIEND_GIFT_COOLDOWN = DateHelper.hoursToMilliseconds(12);
export const LIFE_SEND_COOLDOWN = DateHelper.daysToMilliseconds(3);
export const LIFE_REQUEST_COOLDOWN = DateHelper.daysToMilliseconds(3);
export const LIFE_SHARE_PRIZE_COOLDOWN = DateHelper.daysToMilliseconds(1);
export const LIFE_COOLDOWN = DateHelper.minutesToMilliseconds(30);
export const MISSION_COOLDOWN = DateHelper.hoursToMilliseconds(8);
export const EVENT_COOLDOWN = DateHelper.daysToMilliseconds(7);
export const GATE_UNLOCK_TIMER = DateHelper.daysToMilliseconds(1);
export const APP_RATE_REMINDER_COOLDOWN = DateHelper.daysToMilliseconds(7);
